import script from "./MagicClipsView.vue?vue&type=script&setup=true&lang=js"
export * from "./MagicClipsView.vue?vue&type=script&setup=true&lang=js"

import "./MagicClipsView.vue?vue&type=style&index=0&id=5627f880&lang=scss"

const __exports__ = script;

export default __exports__